exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-list[data-v-6fc96fce] {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    padding: 10px;\n}\n.modal-footer-wrapper[data-v-6fc96fce] {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    width: 100%;\n}\n", ""]);

// exports
